import type { I18nFn } from '#/i18n/types/I18nFn';

export const SearchJobRefinement = {
  AREAS_OF_FOCUS: 'areasOfFocus',
  EDUCATION: 'education',
  FUNCTIONS: 'functions',
  JOB_TYPE: 'jobType',
  LOCALE: 'locale',
  LOCATION_TYPE: 'locationType',
  ORG_TYPE: 'orgType',
  PROFESSIONAL_LEVEL: 'professionalLevel',
  RADIUS: 'radius',
  RECENCY: 'recency',
  HAS_SALARY: 'hasSalary',
  SYNONYM_ID: 'synonymId',
} as const;

export const SEARCH_JOBS_REFINEMENT_NAMES = Object.values(SearchJobRefinement);

export type SearchJobsRefinementType =
  (typeof SearchJobRefinement)[keyof typeof SearchJobRefinement];

export function SEARCH_JOB_REFINEMENT_LABELS(i18n: I18nFn) {
  return {
    [SearchJobRefinement.AREAS_OF_FOCUS]: i18n('Cause Areas'),
    [SearchJobRefinement.EDUCATION]: i18n('Education'),
    [SearchJobRefinement.FUNCTIONS]: i18n('Job Function'),
    [SearchJobRefinement.JOB_TYPE]: i18n('Job Type'),
    [SearchJobRefinement.LOCALE]: i18n('Listing Language'),
    [SearchJobRefinement.LOCATION_TYPE]: i18n('Location Type'),
    [SearchJobRefinement.ORG_TYPE]: i18n('Org Type'),
    [SearchJobRefinement.PROFESSIONAL_LEVEL]: i18n('Experience Level'),
    [SearchJobRefinement.RADIUS]: i18n('Radius'),
    [SearchJobRefinement.RECENCY]: i18n('Recency'),
    [SearchJobRefinement.SYNONYM_ID]: i18n('Job Family'),
  } as Record<SearchJobsRefinementType, string>;
}
